import DeliveryOption from '@/controllers/options/DeliveryOption';
import DeliveryOptionConstants from '@/controllers/options/DeliveryOptionConstants';
import DeliveryOptionsProvider from '@/models/DeliveryOptionsProvider';
import IOptionHandler from './IOptionHandler';

class PauseOptionHandler implements IOptionHandler {
  execute(provider: DeliveryOptionsProvider, map: Map<string, unknown>): void {
    if (map.get(DeliveryOptionConstants.PAUSE_BUTTON)) {
      const deliveryOption: DeliveryOption = new DeliveryOption(DeliveryOptionConstants.PAUSE_BUTTON);
      deliveryOption.addSetting('value', 'true');
      provider.addDeliveryOption(deliveryOption);
    }
  }
}

export default PauseOptionHandler;
